import type { Route } from 'react-resource-router';

import { Logo } from '../common/components/logo';
import { LayoutBoysenberrySidebar } from '../ui/boysenberry/layout-sidebar';
import { BoysenberryCodePage } from '../ui/boysenberry/page-code';
import { BoysenberryCreateEmbedPage } from '../ui/boysenberry/page-create-embed';
import { BoysenberryFlow } from '../ui/boysenberry/page-flow';
import { BoysenberryHome } from '../ui/boysenberry/page-home';
import { HomePage } from '../ui/home';
import { NotFound } from '../ui/not-found';
import { CodePlannerSettings } from '../ui/settings/code-planner/pages/code-planner-settings';
import { CodeReviewerGithubConnections } from '../ui/settings/code-reviewer';

import {
	boysenberryCodePagePath,
	boysenberryCreateEmbedPath,
	boysenberryFlowPath,
	boysenberryPath,
	homePath,
	settingsCodePlannerPath,
	settingsCodeReviewerPath,
} from './paths';

export const homeRoute: Route = {
	name: 'home',
	path: homePath,
	exact: true,
	component: HomePage,
	analyticsName: 'dev-agents-home-page',
};

export const settingsCodeReviewerRoute: Route = {
	name: 'Code Reviewer settings',
	path: settingsCodeReviewerPath,
	exact: true,
	component: CodeReviewerGithubConnections,
	analyticsName: 'dev-agents-code-reviewer-settings-page',
};

export const settingsCodePlannerRoute: Route = {
	name: 'Code Planner settings',
	path: settingsCodePlannerPath,
	exact: true,
	component: CodePlannerSettings,
	analyticsName: 'dev-agents-code-planner-settings-page',
};

export const boysenberryRoute: Route = {
	name: 'Boysenberry',
	path: boysenberryPath,
	exact: true,
	component: BoysenberryHome,
	navigation: LayoutBoysenberrySidebar,
	logo: Logo,
	analyticsName: 'dev-agents-boysenberry-page',
};

export const boysenberryFlowRoute: Route = {
	name: 'Boysenberry flow',
	path: boysenberryFlowPath,
	exact: true,
	component: BoysenberryFlow,
	navigation: LayoutBoysenberrySidebar,
	logo: Logo,
	analyticsName: 'dev-agents-boysenberry-flow-page',
};

export const boysenberryCodePageRoute: Route = {
	name: 'Boysenberry code page',
	path: boysenberryCodePagePath,
	exact: true,
	component: BoysenberryCodePage,
	navigation: LayoutBoysenberrySidebar,
	logo: Logo,
	analyticsName: 'dev-agents-boysenberry-code-page',
};

export const boysenberryCreateEmbedRoute: Route = {
	name: 'Boysenberry create embed',
	path: boysenberryCreateEmbedPath,
	exact: true,
	component: BoysenberryCreateEmbedPage,
	logo: Logo,
	analyticsName: 'dev-agents-boysenberry-create-embed-page',
};

export const notFoundRoute: Route = {
	name: '404',
	path: '',
	component: NotFound,
	analyticsName: 'dev-agents-404-page',
};
